import { Component, Input, ElementRef, AfterContentInit } from '@angular/core';
import * as jQuery from "jquery";
import "slick-carousel"

@Component({
  selector: 'app-slick-slider',
  templateUrl: './slick-slider.component.html',
  styleUrls: ['./slick-slider.component.css']
})
export class SlickSliderComponent implements AfterContentInit {
  @Input() pauseOnClick: boolean;
  @Input() goToSlide: number;
  @Input() options: any;

  $element: any;
  defaultOptions: any = {};
  constructor(private el: ElementRef) {

  }

  ngAfterContentInit() {
    for (var key in this.options) {
      this.defaultOptions[key] = this.options[key];
    }

    this.$element = jQuery(this.el.nativeElement);
    this.$element.slick(this.defaultOptions);
    let currentNativeElement: any = jQuery(this);
    if (this.pauseOnClick) {
      this.$element.click(function () {
        var state = currentNativeElement.data('state');
        switch (state) {
          case 1:
          case undefined:
            currentNativeElement.slick("pause");
            currentNativeElement.find(".slick-slide").addClass("pause-slick");
            currentNativeElement.data('state', 2);
            break;
          case 2:
            currentNativeElement.slick("play");
            currentNativeElement.find(".pause-slick").removeClass("pause-slick");
            currentNativeElement.data('state', 1);
            break;
        }

      });
    }
    if (this.goToSlide) {
      this.movetoslide(this.goToSlide);
    }
  }

  public movetoslide(slide: number) {
    this.$element.slick('slickGoTo', slide, false);
  }
}

